let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4uwca")).then(() => parcelRequire('9aN8a'));